<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已过账</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">其它收款单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate}}</span>
				</span>
				<span class="list-base-right-span">
					本单金额：
					<span class="span-back-color">{{documentItem.originalPrice}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
			    <Col span="8">单据编号：{{documentItem.code}}</Col>
			    <Col span="8">业务日期：{{documentItem.businessDate}}</Col>
			    <Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
			    <Col span="8">付款人：{{documentItem.payer}}</Col>
			    <Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					单据信息
				</div>
			</div>
			<Table :columns="tableColumns" :data="documentItem.otherReceiptDetailLists"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					结算信息
				</div>
			</div>
			<Row class="div-content-row-center">
				<Col span="8">折扣金额：<span class="amount-color">{{documentItem.amount}}</span></Col>
				<Col span="8">已付定金：<span class="amount-color">{{documentItem.payAmount}}</span></Col>
				<Col span="8" v-show="paymentDetail.length<=0">待付金额：<span class="amount-color">{{formatNum(documentItem.amount - documentItem.payAmount)}}</span></Col>
			</Row>
			<div class="div-content-detail">
				<div class="div-content-detail-title">
					收款详情
				</div>
				<div class="div-content-detail-list" v-show="documentItem.payAmount>0">
					<div class="div-content-detail-list-title">定金</div>
					<div class="div-content-detail-list-content">
						<div class="div-content-detail-list-content-item">
							收款日期：
							<span class="span-back-color">
								{{documentItem.businessDate}}
							</span>
						</div>
						<div class="div-content-detail-list-content-item">
							{{documentItem.payWay}}：
							<span class="span-back-color">
								¥&nbsp;{{documentItem.payAmount}}
							</span>
						</div>
					</div>
				</div>
				<div class="div-content-detail-list" v-show="paymentDetail.length>0">
					<div class="div-content-detail-list-title">收款单收款</div>
					<div class="div-content-detail-list-content"  v-for="(item,index) in paymentDetail">
						<div class="div-content-detail-list-content-item">
							收款日期：
							<span class="span-back-color">
								{{item.businessDate}}
							</span>
						</div>
						<div class="div-content-detail-list-content-item">
							{{item.receiptList.payWay}}：
							<span class="span-back-color">
								¥&nbsp;{{item.amountUnpaid}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DocumentFile from '@/components/DocumentFile'
	import formatNum from '@/utils/formatNum'
	export default {
		name: 'otherReceiptplanlistdetail',
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
                    code: '',
                    businessDate: '',
                    amount: 0,
                    payAmount: 0,
                    otherReceiptDetailLists: [],
                    payer: '',
                    discount: 100,
                    userId: '',
                    userName: '',
                    creator: parseInt(localStorage.getItem("userId")),
                    note: '',
                    payWay: '',
                    checkState: 1,//未过账
                    fileList: []
				},
				tableColumns: [
					{
					    title: '行号',
					    key: 'rowNum',
					    width:100
					},
					{
					    title: '费用类别',
					    key: 'costName'
					},
					{
					    title: '金额',
					    key: 'costAmount'
					},
					{
					    title: '备注',
					    key: 'note',
					    width: 500
					}
				],
				paymentDetail:[]
			}
		},

		methods: {
			formatNum(value) {
				// 调用导入的 formatNum 函数
				return formatNum(value);
			},
			getOtherReceiptList(otherReceiptListId) {
				let self = this;
				request.get('/api/OtherReceiptList/GetOtherReceiptList', {
					params: {
						id: otherReceiptListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
					self.getPayDetail(self.documentItem.code);
				}).catch(function(error) {})
			},
			getOtherReceiptListByCode(otherReceiptListCode) {
				let self = this;
				request.get('/api/OtherReceiptList/GetOtherReceiptListByCode', {
					params: {
						code: otherReceiptListCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
					self.getPayDetail(self.documentItem.code);
				}).catch(function(error) {})
			},
			getPayDetail(code){
				let self = this;
				request.get('/api/ReceiptList/GetReceiptDetail', {
					params: {
						code: code
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.paymentDetail = response.data;
				}).catch(function(error) {})
			}
		},
		watch: {
			'$route.query.otherReceiptListId':{
				immediate: true,
				handler(param) {
					if(param){
						this.getOtherReceiptList(param);
					}
				}
			},
			'$route.query.otherReceiptListCode':{
				immediate: true,
				handler(param) {
					if(param){
						this.getOtherReceiptListByCode(param);
					}
				}
			}
		},
		created: function() {
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}
	
	.list-base{
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}
	
	.list-base-left{
		float: left;
		display: flex;
		color: #000;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 100%;           /* 父元素需要固定高度或其它百分比高度 */
	}
	
	.list-base-left-span{
		font-size: 18px;
	}
	
	.list-base-right{
		display: flex;
		float: right;
		justify-content: center; /* 水平居中 */
		align-items: center;    /* 垂直居中 */
		height: 36px;     
	}
	
	.list-base-right-span{
		margin-left: 10px;
	}
	
	.span-back-color{
		color: #000;
	}
	
	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}
	
	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}
	
	.list-module{
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}
	
	.div-content-row div{
		padding: 15px;
	}
	
	.div-content-row-center div{
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}
	
	.amount-color{
		color: rgb(255, 106, 127);
	}
	
	.div-content-detail{
		margin: 15px;
		background-color:#f8f8f9;
		padding: 20px;
	}
	
	.div-content-detail-title{
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}
	.div-content-detail-list{
		margin-top: 10px;
	}
	.div-content-detail-list-title{
		text-indent: 0.5em;
	}
	
	.div-content-detail-list-content{
		overflow: hidden;
	}
	
	.div-content-detail-list-content-item{
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}
	
	.extraReceiptShowTable {
	    margin-top: 10px;
		color: #000;
	}
	
	    .extraReceiptShowTable td {
	        padding: 5px;
	    }
	
</style>